import round from 'lodash/round';
import get from 'lodash/get';

import { formatCurrency, formatDate } from 'shared/functions';
import { parseRatingType } from 'shared/parsers';
import { isNil } from 'lodash';

export const instrumentsToTableParser = (data) => {
  return data.map((item) => {
    const isBlurred =
      ['RESTRICTED_SUBSCRIPTION', 'ON_DEMAND_OPEN_SUBSCRIPTION'].includes(item.ratingType) &&
      !item.hasLicence;

    return [
      parseRatingType(item.ratingType),
      [item.artifactId || item.id, item.product, item.artifactId ? item.id : undefined, isBlurred],
      [item.artifactId || item.id, item.name || item.issueName, isBlurred],
      [item.isin, isBlurred],
      [(item.issuer && item.issuer.name) || item.issuerName, isBlurred],
      [
        item.artifactId || item.id,
        item.product,
        get(item, 'rating.rating'),
        get(item, 'rating.outlook'),
        item.hasLicence,
        item.ratingTrend,
        get(item, 'previousRating.ratingDate', '-'),
        get(item, 'previousRating.outlook', '-'),
        get(item, 'rating.ratingDate', '-'),
        item.rating?.demandType,
        isBlurred,
        item.rating?.id,
        item.rating?.notchSuffix,
        item.rating?.preliminaryFlag,
        item.ratingType,
      ],
      [get(item, 'coupon.maturityDate') ? formatDate(item.coupon.maturityDate) : null, isBlurred],
      [
        !isNil(item.coupon?.couponPercent) ? `${round(item.coupon.couponPercent, 1)}%` : '-',
        isBlurred,
      ],
      [formatCurrency(item.issueVolume, item.currencyCode), isBlurred],
      [item.addedDate, isBlurred],
    ];
  });
};
